import { OrderType } from './interface';
export enum OrderStatus {
  PENDING = 1,
  ACCEPTED = 2,
  WITH_DRIVER = 5,
  CANCELED = 3,
  REJECTED = 0
}


export enum RefreshValue {
  FAVORITE = "favorite",
  CART = "cart",
}

export enum InvoiceCode {
  service = 1,
  fastDriverService = 3,
  driverService = 4,
}
